import EditAccountModalContainer from './EditAccountModalContainer';

export default EditAccountModalContainer;
